/**
 * EventSource相关的混入
 * 处理与AI服务器的通信和消息流
 */
import {
  clearLocalStorageExceptUserGuides,
  clearStorageAndRedirectToLogin,
  redirectToLogin,
} from "@/utils/storageHelper.js";
import { getGuideState, markGuideSeen } from "@/utils/userGuideStorage.js";
import { EventSourcePolyfill } from "event-source-polyfill";
import {
  getRobotIcon2Base64,
  getRobotIcon1Base64,
} from "@/utils/svgToBase64.js";
import { request } from "@/utils/request.js"; // 引入request

export default {
  data() {
    return {
      // 添加分析过程数据存储
      analysisProcesses: [],
      // 标记是否已经插入了分析过程消息
      analysisMessageInserted: false,
      // 分析过程消息ID
      analysisMessageId: null,
      hasMultiHierarchyEvent: false, // 标记是否有canvasGraphEvent事件
    };
  },
  methods: {
    sendToAI(userMsg) {
      // 重置分析过程数据
      this.resetAnalysisProcesses();
      console.log("我是发送的消息");
      console.log(request.defaults.baseURL); // 使用request中的baseURL
      if (this.aiCanvasRobot) {
        if (!this.$route.query.conversationId) {
          this.conversationIdNow = null;
          this.changeRoomName(userMsg, "start");
        } else {
          this.conversationIdNow = this.$route.query.conversationId;
        }
        console.log(this.conversationIdNow);
      }

      this.isStreaming = true;
      this.isloading = true; // 初始化为true，开始加载状态
      // 重置canvasGraphEvent事件标记
      this.hasMultiHierarchyEvent = false;

      // 关闭上一个 EventSource
      if (this.eventSource) {
        console.log("关闭上一个EventSource连接");
        this.eventSource.close();
      }
      let baseUrl;
      // 构建URL
      // baseUrl =
      //   "http://dev.graphchain.top:1001/chain-api/v2/analysis/start/dify/stream";
      baseUrl = this.aiCanvasRobot
        ? request.defaults.baseURL + "/v2/analysis/start/dify/stream"
        : request.defaults.baseURL + "/v2/analysis/start/dify/knowledge/stream";

      const params = new URLSearchParams();
      params.append("prompt", userMsg);

      // 根据知识库启用状态添加参数
      // if (this.knowledgeEnabled === false) {
      //   params.append("knowledgeEnable", "false");
      // }
      if (this.aiCanvasRobot) {
        params.append("aiModelType", this.ai_Model_Types);
        if (this.conversationIdNow) {
          params.append("conversationId", this.conversationIdNow);
        }
      }

      const url = `${baseUrl}?${params.toString()}`;

      console.log("请求URL:", url);
      console.log("发送的消息:", userMsg);
      // 重置输入框高度为初始值
      const textarea = document.querySelector(".vac-textarea");
      if (textarea) {
        textarea.style.height = "40px";
      }
      // 获取SVG Base64 URL
      const robotIcon = this.aiCanvasRobot
        ? getRobotIcon2Base64()
        : getRobotIcon1Base64();

      // 创建一个新的AI消息
      const aiMessageId =
        "ai-msg-" +
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      this.currentAiMessage = {
        _id: aiMessageId,
        content: "",
        senderId: "ai",
        username: "AI助手",
        avatar: robotIcon,
        date: new Date().toLocaleDateString(),
        timestamp: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        html: true,
      };

      // 重置Markdown内容
      this.markdownContent = "";

      // 添加到消息列表
      this.messages.push(this.currentAiMessage);
      this.currentAiMessage.content = this.convertMarkdownToHtml(""); // 显示加载动画
      this.updateLastAiMessage();

      // 获取token
      let token = window.localStorage.getItem("t_k");

      try {
        this.eventSource = new EventSourcePolyfill(url, {
          headers: {
            Authorization: token || "",
            "Content-Type": "text/event-stream",
          },
          heartbeatTimeout: 60000,
          withCredentials: false,
        });

        this.eventSource.onopen = (event) => {
          console.log("EventSource连接已打开:", event);
        };

        this.eventSource.onmessage = (event) => {
          if (!event.data || event.data.trim() === "") {
            return;
          }

          try {
            if (
              event.data === "[DONE]" ||
              event.data === "done" ||
              event.data.includes('"type":"complete"') ||
              event.type == "complete"
            ) {
              this.handleCompletion();
              return;
            }

            try {
              const jsonData = JSON.parse(event.data);

              // if (jsonData.thoughts && Array.isArray(jsonData.thoughts)) {
              //   console.log("处理数据");
              //   this.processThoughtsData(jsonData.thoughts);
              // }

              if (jsonData.text) {
                const filteredText = this.filterSystemMessages(jsonData.text);
                this.conversationIdNow = jsonData.conversationId;
                // console.log(jsonData.conversationId);

                if (!this.$route.query.conversationId && this.aiCanvasRobot) {
                  this.$router.replace({
                    path: this.$route.path,
                    query: {
                      temporarilycanvas: true,
                      conversationId: this.conversationIdNow,
                    },
                  });

                  console.log(this.conversationIdNow);

                  // 检查是否有canvasGraphEvent事件
                  // 如果没有canvasGraphEvent事件，才执行createNewCanvas
                  if (!this.hasMultiHierarchyEvent) {
                    this.$emit("createNewCanvas", this.conversationIdNow);
                  }
                }
                this.taskId = jsonData.taskId;
                if (this.currentAiMessage) {
                  this.currentAiMessage.taskId =
                    this.ai_Model_Types === "ADDRESS_ANALYSIS"
                      ? jsonData.taskId
                      : jsonData.messageId;
                }
                this.markdownContent += filteredText;

                // 保留分析过程内容
                let finalContent = this.convertMarkdownToHtml(
                  this.markdownContent
                );
                if (this.analysisProcesses.length > 0) {
                  const analysisHtml = this.generateAnalysisProcessesHtml();
                  finalContent = analysisHtml + finalContent;
                }

                this.currentAiMessage.content = finalContent;
                this.updateLastAiMessage();
                // 在接收新内容时保持滚动到底部
                if (this.scrollToBottom) {
                  this.scrollToBottom();
                }
              } else if (jsonData.type === "complete") {
                this.handleCompletion();
              } else if (jsonData.data) {
                this.markdownContent += jsonData.data;

                // 保留分析过程内容
                let finalContent = this.convertMarkdownToHtml(
                  this.markdownContent
                );
                if (this.analysisProcesses.length > 0) {
                  const analysisHtml = this.generateAnalysisProcessesHtml();
                  finalContent = analysisHtml + finalContent;
                }

                this.currentAiMessage.content = finalContent;
                this.updateLastAiMessage();
                // 在接收新内容时保持滚动到底部
                if (this.scrollToBottom) {
                  this.scrollToBottom();
                }
              }
            } catch (parseError) {
              if (event.data === "{}") {
                this.handleCompletion();
                return;
              }

              if (event.data.includes("}{")) {
                const jsonParts = event.data
                  .split("}{")
                  .map((part, index, array) => {
                    if (index === 0) return part + "}";
                    if (index === array.length - 1) return "{" + part;
                    return "{" + part + "}";
                  });

                for (const part of jsonParts) {
                  try {
                    const jsonObj = JSON.parse(part);
                    if (jsonObj.text) {
                      this.markdownContent += jsonObj.text;
                    }
                  } catch (e) {}
                }

                // 保留分析过程内容
                let finalContent = this.convertMarkdownToHtml(
                  this.markdownContent
                );
                if (this.analysisProcesses.length > 0) {
                  const analysisHtml = this.generateAnalysisProcessesHtml();
                  finalContent = analysisHtml + finalContent;
                }

                this.currentAiMessage.content = finalContent;
                this.updateLastAiMessage();
                // 在接收新内容时保持滚动到底部
                if (this.scrollToBottom) {
                  this.scrollToBottom();
                }
                return;
              }

              const filteredText = this.filterSystemMessages(event.data);
              this.markdownContent += filteredText;

              // 保留分析过程内容
              let finalContent = this.convertMarkdownToHtml(
                this.markdownContent
              );
              if (this.analysisProcesses.length > 0) {
                const analysisHtml = this.generateAnalysisProcessesHtml();
                finalContent = analysisHtml + finalContent;
              }

              this.currentAiMessage.content = finalContent;
              this.updateLastAiMessage();
              // 在接收新内容时保持滚动到底部
              if (this.scrollToBottom) {
                this.scrollToBottom();
              }
            }
          } catch (e) {
            const filteredText = this.filterSystemMessages(event.data);
            this.markdownContent += filteredText;

            // 保留分析过程内容
            let finalContent = this.convertMarkdownToHtml(this.markdownContent);
            if (this.analysisProcesses.length > 0) {
              const analysisHtml = this.generateAnalysisProcessesHtml();
              finalContent = analysisHtml + finalContent;
            }

            this.currentAiMessage.content = finalContent;
            this.updateLastAiMessage();
            // 在接收新内容时保持滚动到底部
            if (this.scrollToBottom) {
              this.scrollToBottom();
            }
          }
        };

        this.eventSource.onerror = (error) => {
          console.log("失败--------------11111111111111111");
          console.log(error);

          // 检查是否为401错误（token过期）
          if (error && error.status === 401) {
            console.log("Token已过期，需要重新登录");
            // 清除本地存储
            // window.localStorage.clear();
            clearLocalStorageExceptUserGuides();
            // 显示提示信息
            this.markdownContent = "登录已过期，请重新登录";
            this.currentAiMessage.content = this.convertMarkdownToHtml(
              this.markdownContent
            );
            this.updateLastAiMessage();

            // 添加提示信息
            if (this.$message) {
              this.$tbMessage({
                type: "warning",
                text: "登录已过期，请重新登录",
                duration: 2000,
              });
            }

            setTimeout(() => {
              redirectToLogin();
            }, 1000);
            return;
          }

          this.handleEventSourceError(error);
        };

        this.eventSource.addEventListener("complete", (event) => {
          this.handleCompletion();
        });
        // 添加分析过程事件监听
        this.eventSource.addEventListener("analysisProcessEvent", (event) => {
          this.handleAnalysisProcess(event);
        });
        this.eventSource.addEventListener("canvasGraphEvent", (event) => {
          console.log("ai上图的数据");
          console.log(event);
          console.log(event.data);

          // 设置标记为true，表示有canvasGraphEvent事件
          this.hasMultiHierarchyEvent = true;

          this.ProcessCanvasData(event);
          if (!this.$route.query.conversationId && this.aiCanvasRobot) {
            console.log("进入到这里来啦---没有id");
            console.log(event.data.conversationId);

            this.conversationIdNow = event.data.conversationId;
            console.log(this.conversationIdNow);

            this.$router.replace({
              path: this.$route.path,
              query: {
                temporarilycanvas: true,
                conversationId: this.conversationIdNow,
              },
            });
          }
        });
      } catch (error) {
        console.error("创建EventSource时出错:", error);
        this.markdownContent = "连接服务器失败，请稍后再试。";
        this.currentAiMessage.content = this.convertMarkdownToHtml(
          this.markdownContent
        );
        this.isStreaming = false;
        this.updateLastAiMessage();
      }
    },
    //上图
    ProcessCanvasData(event) {
      console.log(event.data);
      let data = event.data;
      if (typeof event.data === "string") {
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          console.error("数据格式转换失败:", e);
        }
      }

      this.onGraphData(data);
    },

    // 处理EventSource错误
    handleEventSourceError(error) {
      // 无论什么错误，都关闭连接
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }

      this.isStreaming = false;
      this.isloading = false; // 重置loading状态

      if (!navigator.onLine) {
        this.markdownContent += "（网络连接已断开）";
      } else if (!this.markdownContent) {
        this.markdownContent = "连接服务器失败，请稍后再试。";
      } else {
        this.markdownContent += "（连接中断）";
      }

      // 保留分析过程内容
      let finalContent = this.convertMarkdownToHtml(this.markdownContent);
      if (this.analysisProcesses.length > 0) {
        const analysisHtml = this.generateAnalysisProcessesHtml();
        finalContent = analysisHtml + finalContent;
      }

      this.currentAiMessage.content = finalContent;
      this.currentAiMessage.saved = true;
      this.currentAiMessage.distributed = true;
      this.currentAiMessage.seen = true;
      this.updateLastAiMessage();
    },

    // 处理AI消息完成
    handleCompletion() {
      if (!this.isStreaming) return;

      this.isStreaming = false;
      this.isloading = false; // 重置loading状态

      // 如果有分析过程，需要将它们添加到当前消息内容前面
      let finalContent = this.convertMarkdownToHtml(this.markdownContent);
      if (this.analysisProcesses.length > 0 && this.currentAiMessage) {
        const analysisHtml = this.generateAnalysisProcessesHtml();
        finalContent = analysisHtml + finalContent;
      }

      // 如果有上图事件，在消息内容后面添加反馈收集组件
      if (this.hasMultiHierarchyEvent && this.currentAiMessage) {
        const feedbackWidget = this.generateFeedbackWidget(
          this.currentAiMessage._id
        );
        finalContent = finalContent + feedbackWidget;
      }

      this.currentAiMessage.content = finalContent;
      this.currentAiMessage.saved = true;
      this.currentAiMessage.distributed = true;
      this.currentAiMessage.seen = true;
      this.updateLastAiMessage();

      // 更新房间最后一条消息 - 移除Markdown标记
      const plainText = this.markdownContent
        .replace(/\*\*(.*?)\*\*/g, "$1") // 移除加粗
        .replace(/\*(.*?)\*/g, "$1") // 移除斜体
        .replace(/#{1,6}\s*/g, "") // 移除标题
        .replace(/`{1,3}(.*?)`{1,3}/g, "$1") // 移除代码标记
        .replace(/\[(.*?)\]\(.*?\)/g, "$1") // 移除链接标记
        .replace(/<\/?[^>]+(>|$)/g, ""); // 移除HTML标签

      this.rooms[0].lastMessage = {
        content:
          plainText.substring(0, 50) + (plainText.length > 50 ? "..." : ""),
        senderId: "ai",
        timestamp: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        saved: true,
        distributed: true,
        seen: true,
      };

      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }

      // 消息完成后确保滚动到底部
      if (this.scrollToBottom) {
        this.scrollToBottom();
      }

      // 消息完成后添加操作图标
      this.$nextTick(() => {
        this.addMessageActionIcons();
        // 如果有反馈组件，绑定交互事件
        if (this.hasMultiHierarchyEvent && this.currentAiMessage) {
          this.bindFeedbackWidgetEvents(this.currentAiMessage._id);
        }
      });
    },

    // 停止AI生成方法
    stopGeneration() {
      console.log("停止生成，任务ID:", this.taskId);

      // 如果有活跃的EventSource连接，关闭它
      if (this.eventSource) {
        // 关闭当前EventSource
        this.eventSource.close();
        this.eventSource = null;

        // 调用后端停止生成接口
        const token = window.localStorage.getItem("t_k");
        const stopUrl =
          request.defaults.baseURL + "/v2/analysis/stop/dify/stream";

        // 添加taskId作为URL参数
        const params = new URLSearchParams();
        if (this.taskId) {
          params.append("taskId", this.taskId);
        }
        // 根据知识库启用状态添加参数
        if (this.knowledgeEnabled === false) {
          params.append("knowledgeEnable", "false");
        }
        const url = `${stopUrl}?${params.toString()}`;

        // 使用XMLHttpRequest
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.setRequestHeader("Authorization", token || "");
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status >= 200 && xhr.status < 300) {
              console.log("停止生成请求发送成功:", xhr.responseText);
            } else if (xhr.status === 401) {
              // 处理token过期情况
              console.log("Token已过期，需要重新登录");
              // 清除本地存储
              // window.localStorage.clear();
              clearLocalStorageExceptUserGuides();
              // 显示提示信息
              this.markdownContent += "\n\n_（登录已过期，请重新登录）_";
              if (this.currentAiMessage) {
                this.currentAiMessage.content = this.convertMarkdownToHtml(
                  this.markdownContent
                );
                this.updateLastAiMessage();
              }

              // 添加提示信息
              this.$tbMessage({
                type: "warning",
                text: "登录已过期，请重新登录",
                duration: 2000,
              });

              setTimeout(() => {
                redirectToLogin();
              }, 1000);

              return;
            } else {
              console.error("停止生成请求失败:", xhr.statusText);
            }
          }
        };

        xhr.send();

        // 更新UI状态
        this.isStreaming = false;
        this.isloading = false; // 重置loading状态
        // 确保输入框内容状态为空
        this.hasInputContent = false;

        // 添加停止生成的提示
        this.markdownContent += "\n\n_（已停止生成）_";
        if (this.currentAiMessage) {
          // 保留分析过程内容
          let finalContent = this.convertMarkdownToHtml(this.markdownContent);
          if (this.analysisProcesses.length > 0) {
            const analysisHtml = this.generateAnalysisProcessesHtml();
            finalContent = analysisHtml + finalContent;
          }

          this.currentAiMessage.content = finalContent;
          this.currentAiMessage.saved = true;
          this.currentAiMessage.distributed = true;
          this.currentAiMessage.seen = true;
          this.updateLastAiMessage();
        }
      }
    },
  },
};
